import { CardElement, ElementsConsumer } from "@stripe/react-stripe-js";
import PropTypes from "prop-types";
import React from "react";

import StripeForm from "./";

class CheckoutStripeForm extends React.PureComponent {
  render() {
    const {
      submitPaymentRequest,
      handleCreateStripeCustomer,
      afterFailedStripeValidation,
      isFormInvalid,
      digitalWalletMode,
      createStripeIntent,
    } = this.props;

    return (
      <ElementsConsumer>
        {({ elements, stripe }) => (
          <StripeForm
            elements={elements}
            stripe={stripe}
            submitPaymentRequest={submitPaymentRequest}
            handleCreateStripeCustomer={handleCreateStripeCustomer}
            afterFailedStripeValidation={afterFailedStripeValidation}
            isFormInvalid={isFormInvalid}
            digitalWalletMode={digitalWalletMode}
            createStripeIntent={createStripeIntent}
          />
        )}
      </ElementsConsumer>
    );
  }
}

export default CheckoutStripeForm;
